import axios from 'axios'

const instance = (useAdminToken = false, signal = null) => {
  const currency = window.localStorage.getItem('siteCurrency') || 'EUR';

  let authToken = localStorage.getItem('x-access-token');
  let otherToken = localStorage.getItem('x-access-token-relation');

  if (useAdminToken && otherToken) {
    authToken = otherToken;
  }

  const tokens = {};
  if (authToken && authToken !== '' && authToken !== 'null') {
    tokens['x-access-token'] = authToken;
  }

  const axiosInstance = axios.create({
    baseURL: process.env.REACT_APP_BACKEND,
    headers: {
      ...tokens,
      currency: currency,
      'ps-token': window?.REST_API_TOKEN
    },
    signal: signal
  });

  // Interceptor: handle 403 Forbidden
  axiosInstance.interceptors.response.use(
    response => response, // pass successful responses
    error => {
      if (error.response?.status === 403) {
        
        let currentPath = window.location.pathname;
        if (currentPath !== '/login')
          window.location.href = '/login'; // redirect to login
      }
      return Promise.reject(error);
    }
  );

  return axiosInstance;
}

export default instance;
